export const data = [
  {
    image: "/images/placements/pmg2.jpeg",
    name: "Jasleen",
    education: "MBA",
    title: "Arvind Fashion",
    id: 172,
  },
  {
    image: "/images/placements/pmg3.jpeg",
    name: "Kritika",
    education: "B.COM",
    title: "Arvind Fashion",
    id: 173,
  },
  {
    image: "/images/placements/pmg4.jpeg",
    name: "Manoj",
    education: "MBA",
    title: "Arvind Fashion",
    id: 174,
  },
  {
    image: "/images/placements/pmg5.jpeg",
    name: "Pallavi",
    education: "MBA",
    title: "Arvind Fashion",
    id: 175,
  },
  {
    image: "/images/placements/pmg6.jpeg",
    name: "Raskirat",
    education: "B.COM",
    title: "Arvind Fashion",
    id: 176,
  },
  {
    image: "/images/placements/me1.jpeg",
    name: "Amrinder",
    education: "B.TECH ME",
    title: "QE at Vijay Engineering Works",
    id: 150,
  },
  {
    image: "/images/placements/me2.jpeg",
    name: "Aryan Pandey",
    education: "B.TECH ME",
    title: "QE at Vijay Engineering Works",
    id: 151,
  },
  {
    image: "/images/placements/me3.jpeg",
    name: "Haseeb",
    education: "B.TECH ME",
    title: "QE at Vijay Engineering Works ",
    id: 152,
  },
  {
    image: "/images/placements/me4.jpeg",
    name: "Prabhdeep",
    education: "B.TECH ME",
    title: "QE at Vijay Engineering Works ",
    id: 153,
  },
  {
    image: "/images/placements/me5.jpeg",
    name: "Raj Shaw",
    education: "B.TECH ME",
    title: "QE at Vijay Engineering Works ",
    id: 154,
  },
  {
    image: "/images/placements/me6.jpeg",
    name: "Suraj Yadav",
    education: "B.TECH ME",
    title: "QE at Vijay Engineering Works ",
    id: 155,
  },
  {
    image: "/images/placements/mgmt1.jpeg",
    name: "Anubhav Grover",
    education: "MBA",
    title: "Muthoot Finance",
    id: 156,
  },
  {
    image: "/images/placements/mgmt2.jpeg",
    name: "Jasmine",
    education: "MBA",
    title: "PieInfoTech Pvt Ltd",
    id: 157,
  },
  {
    image: "/images/placements/mgmt3.jpeg",
    name: "Konika",
    education: "MBA",
    title: "Muthoot Group & Mind Code Lab",
    id: 158,
  },
  {
    image: "/images/placements/mgmt4.jpeg",
    name: "Mayank",
    education: "MBA",
    title: "Cargo Motors ",
    id: 159,
  },
  {
    image: "/images/placements/mgmt5.jpeg",
    name: "Nakul Gupta",
    education: "MBA",
    title: "Cargo Motors ",
    id: 160,
  },
  {
    image: "/images/placements/mgmt6.jpeg",
    name: "Parneet Kaur",
    education: "MBA",
    title: "PieInfoTech Pvt Ltd ",
    id: 161,
  },
  {
    image: "/images/placements/mgmt7.jpeg",
    name: "Tarun",
    education: "MBA",
    title: "PieInfoTech Pvt Ltd ",
    id: 162,
  },
  {
    image: "/images/placements/it1.jpeg",
    name: "Harmilan",
    education: "MCA",
    title: "Knowledge Academy ",
    id: 163,
  },
  {
    image: "/images/placements/it2.jpeg",
    name: "Kunal",
    education: "MCA",
    title: "Sakaar Micro Solutions ",
    id: 164,
  },
  {
    image: "/images/placements/it3.jpeg",
    name: "Manpreet",
    education: "MCA",
    title: "Sacred Heart Hospital",
    id: 165,
  },
  {
    image: "/images/placements/it4.jpeg",
    name: "Priyanshu",
    education: "MCA",
    title: "Software Engineer at Mind Code Lab Pvt Ltd",
    id: 166,
  },
  {
    image: "/images/placements/it5.jpeg",
    name: "Shivam",
    education: "MCA",
    title: "Python Developer at Sensation software solutions Pvt. Ltd ",
    id: 167,
  },
  {
    image: "/images/placements/it6.jpeg",
    name: "Simran",
    education: "MCA",
    title: "Sacred Heart Hospital ",
    id: 168,
  },
  {
    image: "/images/placements/hm1.jpeg",
    name: "Rajwinder",
    education: "BHMCT",
    title: "F&B Service and Event Service Expert at Courtyard by Marriott",
    id: 169,
  },
  {
    image: "/images/placements/hm2.jpeg",
    name: "Manmeet",
    education: "B.VOC(HCM)",
    title: "Trainee Room Attendant at RAMADA ENCORE",
    id: 170,
  },
  {
    image: "/images/placements/pmg1.jpeg",
    name: "Bandana",
    education: "B.COM",
    title: "Arvind Fashion",
    id: 171,
  },

  {
    image: "/images/placements/1.jpeg",
    name: "Abhishek Kumar",
    education: "Junior Software Engineer",
    title: "Netsmartz Infotech Pvt Ltd",
    id: 125,
  },
  {
    image: "/images/placements/2.jpeg",
    name: "Amarpreet",
    education: "Junior Software Developer",
    title: "PIEINFOTECH Pvt Ltd",
    id: 126,
  },
  {
    image: "/images/placements/3.jpeg",
    name: "ANCHAL",
    education: "SOFTWARE TRAINEE",
    title: "SOLITAIRE INFOSYS",
    id: 127,
  },
  {
    image: "/images/placements/4.jpeg",
    name: "Anmol Ashish",
    education: "INTERN",
    title: "Solitaire Infosys ",
    id: 128,
  },
  {
    image: "/images/placements/5.jpeg",
    name: "Bhanu Kumar",
    education: "Software Trainee",
    title: "Step2gen Technology Pvt Ltd",
    id: 129,
  },
  {
    image: "/images/placements/6.jpeg",
    name: "Bhavya",
    education: "Financial Reporting Executive",
    title: "AOSC Technologies",
    id: 130,
  },
  {
    image: "/images/placements/7.jpeg",
    name: "Deepanshu",
    education: "Software Trainee",
    title: "Sensation software solutions Pvt. Ltd",
    id: 131,
  },
  {
    image: "/images/placements/8.jpeg",
    name: "Guramrit Singh",
    education: "Junior Software Developer Trainee",
    title: "Pisoft Informatics Pvt Ltd",
    id: 132,
  },
  {
    image: "/images/placements/9.jpeg",
    name: "Jaskiranpreet",
    education: "Junior Software Developer",
    title: "PIEINFOTECH Pvt Ltd",
    id: 133,
  },
  {
    image: "/images/placements/10.jpeg",
    name: "Kumud",
    education: "Software Trainee",
    title: "Solitaire Infosys ",
    id: 134,
  },
  {
    image: "/images/placements/11.jpeg",
    name: "Madhur",
    education: "INTERN",
    title: "PROTIVITI INDIA MEMBER PRIVATE LIMITED",
    id: 135,
  },
  {
    image: "/images/placements/12.jpeg",
    name: "Mehak",
    education: "Financial Reporting Executive",
    title: "AOSC Technologies",
    id: 136,
  },
  {
    image: "/images/placements/13.jpeg",
    name: "Mehak",
    education: "Financial Reporting Executive",
    title: "AOSC Technologies",
    id: 137,
  },
  {
    image: "/images/placements/14.jpeg",
    name: "Navneet Kaur",
    education: "Junior Software Developer",
    title: "PIEINFOTECH Pvt Ltd",
    id: 138,
  },
  {
    image: "/images/placements/15.jpeg",
    name: "Ritik",
    education: "Junior Software Engineer",
    title: "Netsmartz Infotech India Pvt Ltd",
    id: 139,
  },
  {
    image: "/images/placements/16.jpeg",
    name: "Shobhit Singh Sachdeva",
    education: "Financial Reporting Executive",
    title: "AOSC Technologies",
    id: 140,
  },
  {
    image: "/images/placements/17.jpeg",
    name: "SIMRAN",
    education: "SOFTWARE DEVELOPER",
    title: "PAISSO TECHNOLOGY PRIVATE LIMITED",
    id: 141,
  },
  {
    image: "/images/placements/18.jpeg",
    name: "Tanvir Kaur",
    education: "INTERN",
    title: "FORENSIC CARE NOIDA",
    id: 142,
  },
  {
    image: "/images/placements/19.jpeg",
    name: "Vanshika",
    education: "Financial Reporting Executive",
    title: "AOSC Technologies",
    id: 143,
  },
  {
    image: "/images/placements/20.jpeg",
    name: "Veerpal Kaur",
    education: "Junior Software Engineer",
    title: "Netsmartz Infotech India Pvt Ltd",
    id: 144,
  },
  {
    image: "/images/placements/21.jpeg",
    name: "Zeeshan",
    education: "software development intern",
    title: "75 way Technology Private Limited",
    id: 145,
  },
  {
    image: "/images/placements/Picture6.jpg",
    name: " Harpreet Kaur",
    education: "Full Stack Developer",
    title: "",
    id: 114,
  },
  {
    image: "/images/placements/Picture7.jpg",
    name: "Ravinder Singh",
    education: "Full stack Developer",
    title: "",
    id: 115,
  },
  {
    image: "/images/placements/Picture8.jpg",
    name: " Anjali",
    education: "Python Developer cum Technical writer",
    title: " ECPL & Intellipaat",
    id: 116,
  },
  {
    image: "/images/placements/Picture9.jpg",
    name: "Simranjeet kaur ",
    education: " Intellipaat, Bangalore Designation-Research Analyst",
    title: "",
    id: 117,
  },
  {
    image: "/images/placements/Picture10.jpg",
    name: "Keshav Kanda",
    education: " Software Trainee",
    title: "Solitaire Infosys",
    id: 118,
  },
  {
    image: "/images/placements/Picture11.png",
    name: "Ranjit Kaur",
    education: "Software Trainee",
    title: "Solitaire Infosys Pvt. Ltd.",
    id: 119,
  },
  {
    image: "/images/placements/Picture12.png",
    name: "Anmol Punj",
    education: "Jr.Software developer",
    title: "Delente Technologies",
    id: 120,
  },
  {
    image: "/images/placements/Picture14.jpg",
    name: "Gurpreet Kaur",
    education: "Junior Software Engineer",
    title: "Netsmartz ",
    id: 121,
  },
  {
    image: "/images/placements/Picture16.jpg",
    name: "Yaskaran",
    education: "Trainee - Software Engineer/Web Developer",
    title: "Relinns Technologies",
    id: 122,
  },
  {
    image: "/images/placements/Picture17.jpg",
    name: "Sourav Joshi",
    education: "Research Analyst",
    title: "Intellipaat, Bangalore ",
    id: 123,
  },
  {
    // image: '/images/pankajkumar.jpg',
    image: "/images/placements/pankajkumar.jpg",
    name: "Pankaj Kumar",
    education: "B.Tech(CSE)",
    title: "SV Footwear",
    id: 1,
  },
  {
    image: "/images/placements/Anamika-Sharma.jpg",
    name: "Anamika Sharma",
    education: "B.Tech(CSE)",
    title: "Wipro",
    id: 2,
  },
  {
    image: "/images/placements/Navdeep-Kaur.jpg",
    name: "Navdeep kaur",
    education: "B.Tech(CSE)",
    title: "SEASIA INFOTECH & SEASIA INFOTECH",
    id: 3,
  },
  {
    image: "/images/placements/komal-.jpg",
    name: "Komal",
    education: "B.Tech(CSE)",
    title: "Pepcoding",
    id: 4,
  },
  {
    image: "/images/placements/Navjot-Kaur.jpg",
    name: "Navjot kaur",
    education: "B.Tech(CSE)",
    title: "Seasia",
    id: 5,
  },
  {
    image: "/images/placements/Nitika.jpg",
    name: "Nikita",
    education: "B.Tech(CSE)",
    title: "Pepcoding",
    id: 6,
  },
  {
    image: "/images/placements/Ranjna.jpg",
    name: "Ranjna",
    education: "B.Tech(CSE)",
    title: "TECH MAHINDRA",
    id: 7,
  },
  {
    image: "/images/placements/Shabnam.jpg",
    name: "Shabnam",
    education: "B.Tech(CSE)",
    title: "RACLOOP TECHNOLOGIES PVT. LTD.",
    id: 8,
  },
  {
    image: "/images/placements/AjayParmar.jpg",
    name: "Ajay Parmar",
    education: "B.Tech(CSE)",
    title: "SEASIA INFOTECH",
    id: 9,
  },
  {
    image: "/images/placements/RajpreetSingh.jpg",
    name: "Rajpreet Singh",
    education: "B.Tech(CSE)",
    title: "SEASIA INFOTECH",
    id: 10,
  },
  {
    image: "/images/placements/GurvinderSingh1.jpg",
    name: "Gurvinder Singh",
    education: "B.Tech(CSE)",
    title: "SEASIA INFOTECH",
    id: 11,
  },

  {
    image: "/images/placements/HarinderKaur1.jpg",
    name: "Harinder Kaur",
    education: "B.Tech(CSE)",
    title: "SEASIA INFOTECH",
    id: 13,
  },
  {
    image: "/images/placements/Rahulyadav1.jpg",
    name: "Rahul Yadav",
    education: "B.Tech(CSE)",
    title: "B.Tech. (CSE)BEBO TECHNOLOGY AND SEASIA INFOTECH",
    id: 14,
  },
  {
    image: "/images/placements/DeepakPatel1.jpg",
    name: "Deepak Patel",
    education: "B.Tech(CSE)",
    title: "RTS CORPORATION",
    id: 15,
  },
  {
    image: "/images/placements/HargunRana.jpg",
    name: "Hargun Rana",
    education: "B.Tech(CSE)",
    title: "AMAZON",
    id: 16,
  },
  {
    image: "/images/placements/NavneetKaur.jpg",
    name: "Navneet kaur",
    education: "B.Tech(CSE)",
    title: "ECPL",
    id: 18,
  },
  {
    image: "/images/placements/PawandeepSingh.jpg",
    name: "Pawandeep singh",
    education: "B.Tech(CSE)",
    title: "NUCLEUS SOFTWARE AND ECPL",
    id: 19,
  },
  {
    image: "/images/placements/RichuMehta1.jpg",
    name: "Richu Mehta",
    education: "B.Tech(CSE)",
    title: "PEPCODING EDUCATION PVT. LTD.",
    id: 20,
  },
  {
    image: "/images/placements/kushpreetk.jpg",
    name: "Kushpreet Kaur",
    education: "B.Tech(CSE)",
    title: "IP SERVICES PRIVATE LIMITED",
    id: 21,
  },
  {
    image: "/images/placements/namarta.jpg",
    name: "Namarta",
    education: "B.Tech(CSE)",
    title: "IP SERVICES PRIVATE LIMITED",
    id: 22,
  },

  {
    image: "/images/placements/jatin.jpg",
    name: "Jatin",
    education: "B.Tech(CSE)",
    title: "ChicMic",
    id: 23,
  },
  {
    image: "/images/placements/rahuljindal001.jpg",
    name: "Rahul Jindal",
    education: "B.Tech(CSE)",
    title: "Zapbuild",
    id: 24,
  },
  {
    image: "/images/placements/MAMTA.jpg",
    name: "Mamta Kumari",
    education: "B.Tech(CSE)",
    title: "SACH TECH",
    id: 25,
  },
  {
    image: "/images/placements/Ramandeepkaur.jpg",
    name: "Ramandeep kaur",
    education: "B.Tech(CSE)",
    title: "INIZ Solutions",
    id: 26,
  },
  {
    image: "/images/placements/Jyotisharma.jpg",
    name: "Jyoti sharma",
    education: "B.Tech(CSE)",
    title: "INIZ Solutions",
    id: 27,
  },
  {
    image: "/images/placements/rosy.jpg",
    name: "Rosy Mehta",
    education: "B.Tech(CSE)",
    title: "Netsmartz Limited",
    id: 28,
  },
  {
    image: "/images/placements/manpreet002.jpg",
    name: "Manpreet Kaur",
    education: "B.Tech(CSE)",
    title: "BYJU'S",
    id: 29,
  },
  {
    image: "/images/placements/pl-04.jpg",
    name: "Hitesh",
    education: "B.Tech(CSE)",
    title: "Advance Solutions & Cognitier Technologies",
    id: 30,
  },
  {
    image: "/images/placements/aakriti001.jpg",
    name: "Aakriti",
    education: "B.Tech(ECE)",
    title: "Mphasis & Advance Solutions",
    id: 31,
  },
  {
    image: "/images/placements/manpreet001.jpg",
    name: "Manpreet kaur",
    education: "B.Tech(CSE)",
    title: "Advance Solutions",
    id: 32,
  },
  {
    image: "/images/placements/sunidhi001.jpg",
    name: "Sunidhi",
    education: "B.Tech(ECE)",
    title: "Advance Solutions",
    id: 33,
  },
  {
    image: "/images/placements/anjali001.jpg",
    name: "Anjali",
    education: "B.Tech(CSE)",
    title: "Advance Solutions",
    id: 34,
  },
  {
    image: "/images/placements/ritikapathak.jpg",
    name: "Ritika Pathak",
    education: "B.Tech(CSE)",
    title: "Seasia",
    id: 35,
  },
  {
    image: "/images/placements/anamika.jpg",
    name: "Anamika",
    education: "B.Tech(CSE)",
    title: "Seasia",
    id: 36,
  },
  {
    image: "/images/placements/ritikchugh.jpg",
    name: "Ritik Chugh",
    education: "B.Tech(CSE)",
    title: "Seasia",
    id: 37,
  },
  {
    image: "/images/placements/muskangulati.jpg",
    name: "Muskan Gulati",
    education: "B.Tech(CSE)",
    title: "Smart Data Enterprises",
    id: 38,
  },
  {
    image: "/images/placements/amanpreetkaur.jpg",
    name: "Amanpreet Kaur",
    education: "B.Tech(CSE)",
    title: "BEBO technology",
    id: 39,
  },
  {
    image: "/images/placements/pardeepkaur.jpg",
    name: "Pardeep Kaur",
    education: "B.Tech(CSE)",
    title: "Tele performance technology",
    id: 40,
  },
  {
    image: "/images/placements/gurpinderkaur.jpg",
    name: "Gurpinder Kaur",
    education: "B.Tech(CSE)",
    title: "ADVANCE solutions",
    id: 41,
  },
  {
    image: "/images/placements/rubykala.jpg",
    name: "Ruby Kala",
    education: "B.Tech(CSE)",
    title: "BEBO Technology & Seasia",
    id: 42,
  },
  {
    image: "/images/placements/jagjot.jpg",
    name: "Jagjot Singh",
    education: "B.Tech(ECE)",
    title: "SUKHJIT STARCH, PHAGWARA",
    id: 43,
  },
  {
    image: "/images/placements/divyansh.jpg",
    name: "Divyansh Kaushal",
    education: "B.Tech(CSE)",
    title: "GNA Gears",
    id: 44,
  },

  {
    image: "/images/placements/rahulkumar.jpg",
    name: "Rahul Kumar",
    education: "B.Tech(CSE)",
    title: "GNA Gears",
    id: 45,
  },

  {
    image: "/images/placements/sarabjeet.jpg",
    name: "Sarbjeet",
    education: "B.Tech(ECE)",
    title: "GNA Gears",
    id: 46,
  },
  {
    image: "/images/placements/prabhjotsingh-1.jpg",
    name: "Prabhjot singh",
    education: "B.Tech(ECE)",
    title: "GNA Gears",
    id: 47,
  },
  {
    image: "/images/placements/daljitsingh.jpg",
    name: "Daljit singh",
    education: "B.Tech(ME)",
    title: "SV Footwear",
    id: 48,
  },
  {
    image: "/images/placements/devinderpal.jpg",
    name: "Devinderpal singh",
    education: "B.Tech(ME)",
    title: "SV Footwear",
    id: 49,
  },
  {
    image: "/images/placements/gurpreetsingh.jpg",
    name: "Gurpreet singh",
    education: "B.Tech(ME)",
    title: "SV Footwear",
    id: 50,
  },
  {
    image: "/images/placements/happykumar.jpg",
    name: "Happy Kumar",
    education: "B.Tech(ME)",
    title: "SV Footwear",
    id: 51,
  },
  {
    image: "/images/placements/lalitkumar.jpg",
    name: "Lalit Kumar",
    education: "B.Tech(ME)",
    title: "Pankaj Kumar",
    id: 52,
  },
  {
    image: "/images/placements/pankajkumar.jpg",
    name: "Pankaj Kumar",
    education: "B.Tech(ME)",
    title: "SV Footwear",
    id: 53,
  },
  {
    image: "/images/placements/parampreet.jpg",
    name: "Parampreet",
    education: "B.Tech(ME)",
    title: "SV Footwear",
    id: 54,
  },
  {
    image: "/images/placements/vijinderkumar.jpg",
    name: "Vijinder Kumar",
    education: "B.Tech(ME)",
    title: "SV Footwear",
    id: 55,
  },
  {
    image: "/images/placements/shivam.jpg",
    name: "Shivam",
    education: "B.Tech(ME)",
    title: "Krome Dispense",
    id: 56,
  },
  {
    image: "/images/placements/jatinduggal.jpg",
    name: "Jatin Duggal",
    education: "B.Tech(ME)",
    title: "Krome Dispense",
    id: 57,
  },
  {
    image: "/images/placements/harpreetsingh.jpg",
    name: "Harpreet Singh Gill",
    education: "B.Tech(ME)",
    title: "Krome Dispense",
    id: 58,
  },
  {
    image: "/images/placements/shubhamsingh.jpg",
    name: "Shubham Singh",
    education: "B.Tech(ME)",
    title: "Krome Dispens",
    id: 59,
  },
  {
    image: "/images/placements/arunkumar.jpg",
    name: "Arun Kumar",
    education: "B.Tech(ME)",
    title: "Krome Dispense",
    id: 60,
  },
  {
    image: "/images/placements/1538475.jpg",
    name: "TWINKLE PUNJ",
    education: "B.Tech(ME)",
    title: "WIPRO",
    id: 61,
  },
  {
    image: "/images/placements/1538442.jpg",
    name: "Kashish Kumar",
    education: "B.Tech(CSE)",
    title: "WIPRO ",
    id: 62,
  },
  {
    image: "/images/placements/rishabhjain-1.jpg",
    name: "Rishabh Jain",
    education: "B.Tech(CSE)",
    title: "Cogniter Technologies",
    id: 63,
  },
  {
    image: "/images/placements/ritika001.jpg",
    name: "Ritika",
    education: "B.Tech(CSE)",
    title: "Radsol Design PVT. LTD.",
    id: 64,
  },
  {
    image: "/images/placements/anusaini.jpg",
    name: "Anu Saini",
    education: "B.Tech(CSE)",
    title: "GoTeSo Pvt. Ltd.",
    id: 65,
  },
  {
    image: "/images/placements/jaspreetkaur.jpg",
    name: "Jaspreet Kaur",
    education: "B.Tech(ECE)",
    title: "GoTeSo Pvt. Ltd.",
    id: 66,
  },
  {
    image: "/images/placements/nitin.jpg",
    name: "Nitin",
    education: "B.Tech(ECE)",
    title: "GoTeSo Pvt. Ltd",
    id: 67,
  },
  {
    image: "/images/placements/narinderkaur.jpg",
    name: "Narinder Kaur",
    education: "B.Tech(ECE)",
    title: "CINIF Technologies Pvt. Ltd.",
    id: 68,
  },
  {
    image: "/images/placements/nitish.jpg",
    name: "Nitish",
    education: "B.Tech(ECE)",
    title: "CINIF Technologies Pvt. Ltd.",
    id: 69,
  },

  {
    image: "/images/placements/shifali.jpg",
    name: "Shifali",
    education: "B.Tech(ECE)",
    title: "CINIF Technologies Pvt. Ltd.",
    id: 70,
  },

  {
    image: "/images/placements/divyamjain.jpg",
    name: "Divyam Jain",
    education: "B.Tech(ECE)",
    title: "CINIF Technologies Pvt. Ltd.",
    id: 71,
  },

  {
    image: "/images/placements/1449600.jpg",
    name: "Suraj",
    education: "B.Tech(ECE)",
    title: "OATI",
    id: 72,
  },

  {
    image: "/images/placements/1538435.jpg",
    name: "Gaurav Badhan",
    education: "B.Tech(ECE)",
    title: "EDUCATION CULTURE PVT. LTD.",
    id: 73,
  },
  {
    image: "/images/placements/1538440.jpg",
    name: "Kajal Satija",
    education: "B.Tech(CSE)",
    title: "TCS",
    id: 74,
  },
  {
    image: "/images/placements/karna.jpg",
    name: "Karuna",
    education: "B.Tech(ECE)",
    title: "GOTESO",
    id: 75,
  },
  {
    image: "/images/placements/1538448.jpg",
    name: "Manmeet Kaur",
    education: "B.Tech(CSE)",
    title: "DEFACTO INFOTECH PVT. LTD.",
    id: 76,
  },
  {
    image: "/images/placements/1538450.jpg",
    name: "Mrinaal",
    education: "B.Tech(CSE)",
    title: "IMPINGE SOLUTIONS",
    id: 77,
  },
  {
    image: "/images/placements/1538455.jpg",
    name: "Paras Dua",
    education: "B.Tech(CSE)",
    title: "TCS",
    id: 78,
  },
  {
    image: "/images/placements/1538457.jpg",
    name: "Priyanka Bhutani",
    education: "B.Tech(CSE)",
    title: "EDUCATION CULTURE PVT. LTD.",
    id: 79,
  },
  {
    image: "/images/placements/poojarani.jpg",
    name: "Pooja Rani",
    education: "B.Tech(CSE)",
    title: "EDUCATION CULTURE PVT. LTD.",
    id: 80,
  },
  {
    image: "/images/placements/1538469.jpg",
    name: "Baljeet Singh",
    education: "B.Tech(CSE)",
    title: "PROMATICS",
    id: 81,
  },
  {
    image: "/images/placements/1538469a.jpg",
    name: "Sukhwinder Singh",
    education: "B.Tech(CSE)",
    title: "DEFACTO INFOTECH PVT. LTD.",
    id: 82,
  },
  {
    image: "/images/placements/1538474.jpg",
    name: "Sweksha Shukla",
    education: "B.Tech(CSE)",
    title: "EDUCATION CULTURE PVT. LTD.",
    id: 83,
  },
  {
    image: "/images/placements/1538630.jpg",
    name: "Rupinder Singh",
    education: "B.Tech(CSE)",
    title: "OATI",
    id: 84,
  },
  {
    image: "/images/placements/1632744.jpg",
    name: "Harjot Kaur",
    education: "B.Tech(CSE)",
    title: "SOLITAIRE INFOSYS",
    id: 85,
  },
  {
    image: "/images/placements/1632750.jpg",
    name: "Ketan Sharma",
    education: "B.Tech(CSE)",
    title: "COGNITER TECHNOLOGIES",
    id: 86,
  },
  {
    image: "/images/placements/1632755.jpg",
    name: "Monika",
    education: "B.Tech(CSE)",
    title: "Monika",
    id: 87,
  },
  {
    image: "/images/placements/amritpal.jpg",
    name: "Amritpal kaur",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 88,
  },
  {
    image: "/images/placements/arun.jpg",
    name: "Arun",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 89,
  },
  {
    image: "/images/placements/bhanupartap.jpg",
    name: "Bhanu Partap",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 90,
  },
  {
    image: "/images/placements/hargun.jpg",
    name: "Hargun",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 91,
  },
  {
    image: "/images/placements/harinder.jpg",
    name: "Harinder",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 92,
  },
  {
    image: "/images/placements/jatin_1.jpg",
    name: "Jatin",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 93,
  },
  {
    image: "/images/placements/karandeep.jpg",
    name: "Karandeep",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 94,
  },
  {
    image: "/images/placements/komal.jpg",
    name: "Komal",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 95,
  },
  {
    image: "/images/placements/navdeepkaur.jpg",
    name: "Navdeep Kaur",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 96,
  },
  {
    image: "/images/placements/pawandeepsingh_1.jpg",
    name: "Pawandeep",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 97,
  },
  {
    image: "/images/placements/richu.jpg",
    name: "Richu",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 98,
  },
  {
    image: "/images/placements/samritivashisht.jpg",
    name: "Samriti Vashisht",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 100,
  },
  {
    image: "/images/placements/sharanjitkaur.jpg",
    name: "Sharajit Kaur",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 101,
  },
  {
    image: "/images/placements/shivamsharma.jpg",
    name: "Shivam Sharma",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 102,
  },
  {
    image: "/images/placements/jaspreet.jpg",
    name: "Jaspreet",
    education: "B.Tech(CSE)",
    title: "IBM",
    id: 103,
  },
  {
    image: "/images/placements/kamal.jpg",
    name: "Kamal",
    education: "B.Tech(ECE)",
    title: "IBM",
    id: 104,
  },
  {
    image: "/images/placements/khushpreetkaur.jpg",
    name: "Khushpreet kaur",
    education: "B.Tech(ECE)",
    title: "IBM",
    id: 105,
  },
  {
    image: "/images/placements/lavankshi.jpg",
    name: "Lavankshi",
    education: "B.Tech(ECE)",
    title: "IBM",
    id: 106,
  },
  {
    image: "/images/placements/simranbhagat.jpg",
    name: "Simran Bhagat",
    education: "B.Tech(ECE)",
    title: "IBM",
    id: 107,
  },
  {
    image: "/images/placements/sourav.jpg",
    name: "Sourav",
    education: "B.Tech(ECE)",
    title: "IBM",
    id: 108,
  },
  {
    image: "/images/placements/anmol.jpg",
    name: "Anmoldeep Saini",
    education: "Associate Software developer",
    title: " Chicmic ",
    id: 109,
  },
  {
    image: "/images/placements/Picture2.jpg",
    name: "Shashank Malhotra",
    education: "",
    title: "Education Culture Pvt Ltd (ECPL)",
    id: 110,
  },
  {
    image: "/images/placements/Picture3.jpg",
    name: "Akshay Kalia",
    education: "Frontend Developer",
    title: "",
    id: 111,
  },
  {
    image: "/images/placements/Picture4.jpg",
    name: "Anoop Kumar",
    education: "Full Stack Developer",
    title: "",
    id: 112,
  },
  {
    image: "/images/placements/Picture5.jpg",
    name: "Jaspreet Singh",
    education: "Full Stack Developer",
    title: "",
    id: 113,
  },

  // {
  //   // image: require("../../../assets/images/"),
  //   name: "",
  //   education: "",
  //   title:"",
  //   id: 124,
  // },
  // {
  //   // image: require("../../../assets/images/"),
  //   name: "",
  //   education: "",
  //   title:"",
  //   id: 125,
  // },
  // {
  //   // image: require("../../../assets/images/"),
  //   name: "",
  //   education: "",
  //   title:"",
  //   id: 126,
  // },
  // {
  //   // image: require("../../../assets/images/"),
  //   name: "",
  //   education: "",
  //   title:"",
  //   id: 127,
  // },
  // {
  //   // image: require("../../../assets/images/"),
  //   name: "",
  //   education: "",
  //   title:"",
  //   id: 128,
  // },
];
